<template>
  <router-view />
</template>

<script>
export default {
  name: "app",
};
</script>

<style>
html,
body {
  overscroll-behavior-y: none;
}
</style>
